import { Box, Collapse } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { Alert, AlertProps } from './alert.components';


const useStyles = makeStyles({ name: 'FloatingAlert' })({
  root: {
    width: '100%',
    display: 'block',
    position: 'relative',
  },
  container: {
    position: 'absolute',
    width: '100%',
    zIndex: 1000,
  }
});


export type FloatingAlertProps = AlertProps & {
  open?: boolean;
};


export const FloatingAlert: React.FC<FloatingAlertProps> = (props) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.container}>
        <Collapse in={props.open ?? false}>
          <Alert {...props} />
        </Collapse>
      </Box>
    </Box>
  );
};
